<template>
  <div class="specific-business-main">
    <header>特定业务</header>
    <main>
      <div v-for="(item, index) in specificElementVOs" :key="index">
        <div class="business-item">
          <i v-if="!isSingle && !readonly" @click="handleClearBusiness($event, index)" class="iconfont clear" slot="button">&#xe60b;</i>
          <FormList
            v-if="elementCode === '09'"
            :list="getElementCode09(item)"
            :data="item"
            :onChange="(arg) => onInputChange({ ...arg, index })"
            :onBlur="onBlur"
            :onFocus="onFocus"
          />
          <FormList
            v-else
            :list="getColumnsByCode"
            :data="item"
            :onChange="(arg) => onInputChange({ ...arg, index })"
            :onBlur="onBlur"
            :onFocus="onFocus"
          />
        </div>
      </div>
      <div class="add" v-if="!isSingle && !readonly" @click="handleAdd">添加业务</div>
    </main>
  </div>
</template>

<script>
import {
  AREA_UNIT,
  WHETHER_OR_NOT,
  TYPE_OF_VEHICLE,
  TRAVEL_LEVEL_MAP,
  TYPE_OF_TRANSPORTATION,
  TOURISM_SERVICES_DOCUMENT_TYPE_MAP
} from '@assets/config'
import { Notify } from 'vant'
import FormList from '@components/FormList'
import regionMaping from '@assets/regionMaping.js'
import { renderTextWithConfig, deepCopy, getWebCache, setWebCache } from '@utils/basicUtil'
export default {
  name: 'HuisuiyunMobileClientIndex',
  components: {
    FormList
  },
  watch: {
    elementCode (v) {
      this.initData()
    }
  },
  props: {
    elementCode: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    useCache: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getColumnsByCode () {
      return this.elementCode ? this[`elementCode${this.elementCode}`] : []
    },
    getElementCode09 () {
      return (item) => {
        const fieldList = deepCopy(this.elementCode09)
        const fieldItem = fieldList[fieldList.length - 1]
        if (['1', '2', '7'].includes(item.elementExt7)) {
          fieldItem.type = 'select'
          fieldItem.placeholder = '请选择'
          fieldItem.options = TRAVEL_LEVEL_MAP[item.elementExt7]
          fieldItem.render = (text) => renderTextWithConfig(text, TRAVEL_LEVEL_MAP[item.elementExt7])
        } else {
          fieldItem.placeholder = '请输入'
          fieldItem.type = 'text'
        }
        fieldList.splice(fieldList.length - 1, 1, fieldItem)
        return fieldList
      }
    },
    isSingle () {
      return ['03', '05', '06'].includes(this.elementCode)
    }
  },
  data () {
    return {
      specificElementVOs: [{
        elementExt1: '',
        elementExt2: '',
        elementExt3: '',
        elementExt4: '',
        elementExt5: '',
        elementExt6: '',
        elementExt7: '',
        elementExt8: '',
        elementExt9: '',
        elementExt10: ''
      }],
      // 建筑服务
      elementCode03: [
        {
          type: 'cascader',
          field: 'elementExt1',
          placeholder: this.readonly ? '' : '请选择',
          label: '建筑服务发生地省市区县',
          options: regionMaping,
          required: true,
          readonly: this.readonly,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt2',
          placeholder: this.readonly ? '' : '请输入',
          label: '建筑服务发生地详细地址',
          readonly: this.readonly,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt3',
          placeholder: this.readonly ? '' : '请输入',
          label: '建筑项目名称',
          readonly: this.readonly,
          required: true,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt4',
          placeholder: this.readonly ? '' : '请输入',
          label: '土地增值税项目编号',
          readonly: this.readonly,
          align: 'right'
        },
        {
          type: 'select',
          field: 'elementExt5',
          placeholder: this.readonly ? '' : '请选择',
          required: true,
          label: '跨地（市）标志',
          readonly: this.readonly,
          disabled: this.readonly,
          options: WHETHER_OR_NOT,
          align: 'right',
          render: (text) => renderTextWithConfig(text, WHETHER_OR_NOT)
        }
      ],
      // 货物运输
      elementCode04: [
        {
          type: 'select',
          field: 'elementExt4',
          placeholder: this.readonly ? '' : '请选择',
          label: '项目运输工具种类',
          options: TYPE_OF_TRANSPORTATION,
          align: 'right',
          disabled: this.readonly,
          readonly: this.readonly,
          required: true,
          render: (text) => renderTextWithConfig(text, TYPE_OF_TRANSPORTATION)
        },
        {
          type: 'text',
          field: 'elementExt3',
          placeholder: this.readonly ? '' : '请输入',
          label: '运输工具牌号',
          required: true,
          readonly: this.readonly,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt2',
          placeholder: this.readonly ? '' : '请输入',
          label: '起运地',
          readonly: this.readonly,
          required: true,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt1',
          placeholder: this.readonly ? '' : '请输入',
          label: '到达地',
          readonly: this.readonly,
          required: true,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt5',
          placeholder: this.readonly ? '' : '请输入',
          required: true,
          readonly: this.readonly,
          label: '运输货物名称',
          align: 'right'
        }
      ],
      // 不动产销售服务
      elementCode05: [
        {
          type: 'text',
          field: 'elementExt6',
          placeholder: this.readonly ? '' : '请输入',
          readonly: this.readonly,
          label: '不动产单元代码/网签合同备案号',
          align: 'right'
        },
        {
          type: 'cascader',
          field: 'elementExt2',
          placeholder: this.readonly ? '' : '请输入',
          label: '不动产地址',
          readonly: this.readonly,
          required: true,
          options: regionMaping,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt3',
          placeholder: this.readonly ? '' : '"请输入，必须包含“村/路/乡/镇/道/巷/号”等关键词"',
          required: true,
          readonly: this.readonly,
          label: '详细地址',
          align: 'right'
        },
        {
          type: 'select',
          field: 'elementExt4',
          placeholder: this.readonly ? '' : '请选择',
          label: '跨地（市）标志',
          required: true,
          readonly: this.readonly,
          disabled: this.readonly,
          options: WHETHER_OR_NOT,
          align: 'right',
          render: (text) => renderTextWithConfig(text, WHETHER_OR_NOT)
        },
        {
          type: 'text',
          field: 'elementExt7',
          placeholder: this.readonly ? '' : '请输入',
          label: '土地增值税项目编号',
          align: 'right',
          readonly: this.readonly
        },
        {
          type: 'text',
          field: 'elementExt8',
          placeholder: this.readonly ? '' : '请输入',
          label: '核定计税价格',
          readonly: this.readonly,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt9',
          placeholder: this.readonly ? '' : '请输入',
          label: '实际成交含税金额',
          readonly: this.readonly,
          required: true,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt1',
          placeholder: this.readonly ? '' : '请输入',
          label: '房屋产权证书/不动产权证号',
          readonly: this.readonly,
          align: 'right'
        },
        {
          type: 'select',
          field: 'elementExt5',
          placeholder: this.readonly ? '' : '请选择',
          label: '实际面积单位',
          readonly: this.readonly,
          disabled: this.readonly,
          required: true,
          options: AREA_UNIT,
          align: 'right',
          render: (text) => renderTextWithConfig(text, AREA_UNIT)
        }
      ],
      // 不动产经营租赁服务
      elementCode06: [
        {
          type: 'cascader',
          field: 'elementExt2',
          placeholder: this.readonly ? '' : '请输入',
          label: '不动产地址',
          readonly: this.readonly,
          required: true,
          options: regionMaping,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt3',
          placeholder: this.readonly ? '' : '请输入',
          required: true,
          readonly: this.readonly,
          label: '不动产详细地址',
          align: 'right'
        },
        {
          type: 'date',
          field: 'elementExt4',
          placeholder: this.readonly ? '' : '请选择',
          label: '租赁期起',
          required: true,
          readonly: this.readonly,
          align: 'right',
          dateType: 'range',
          rangeField: 'elementExt5',
          isNewAssembly: true
        },
        {
          type: 'date',
          field: 'elementExt5',
          placeholder: this.readonly ? '' : '请选择',
          label: '租赁期止',
          align: 'right',
          readonly: this.readonly,
          required: true,
          dateType: 'range',
          rangeField: 'elementExt4',
          isNewAssembly: true
        },
        {
          type: 'text',
          field: 'elementExt1',
          placeholder: this.readonly ? '' : '请输入',
          required: true,
          readonly: this.readonly,
          label: '产权证书/不动产权证号',
          align: 'right'
        },
        {
          type: 'select',
          field: 'elementExt6',
          placeholder: this.readonly ? '' : '请选择',
          label: '跨地（市）标志',
          required: true,
          disabled: this.readonly,
          readonly: this.readonly,
          options: WHETHER_OR_NOT,
          align: 'right',
          render: (text) => renderTextWithConfig(text, WHETHER_OR_NOT)
        },
        {
          type: 'select',
          field: 'elementExt7',
          placeholder: this.readonly ? '' : '请选择',
          label: '实际面积单位',
          required: true,
          disabled: this.readonly,
          readonly: this.readonly,
          options: AREA_UNIT,
          align: 'right',
          render: (text) => renderTextWithConfig(text, AREA_UNIT)
        }
      ],
      // 旅客运输服务
      elementCode09: [
        {
          type: 'text',
          field: 'elementExt1',
          placeholder: this.readonly ? '' : '请输入',
          label: '出行人',
          required: true,
          readonly: this.readonly,
          align: 'right'
        },
        {
          type: 'date',
          field: 'elementExt4',
          placeholder: this.readonly ? '' : '请选择',
          label: '出行日期',
          required: true,
          readonly: this.readonly,
          align: 'right',
          isNewAssembly: true
        },
        {
          type: 'select',
          field: 'elementExt2',
          placeholder: this.readonly ? '' : '请选择',
          label: '出行人证件类型',
          required: true,
          readonly: this.readonly,
          disabled: this.readonly,
          options: TOURISM_SERVICES_DOCUMENT_TYPE_MAP,
          align: 'right',
          render: (text) => renderTextWithConfig(text, TOURISM_SERVICES_DOCUMENT_TYPE_MAP)
        },
        {
          type: 'text',
          field: 'elementExt3',
          placeholder: this.readonly ? '' : '请输入',
          label: '出行人证件号码',
          required: true,
          readonly: this.readonly,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt5',
          required: true,
          placeholder: this.readonly ? '' : '请输入',
          label: '出发地',
          readonly: this.readonly,
          align: 'right'
        },
        {
          type: 'text',
          field: 'elementExt6',
          placeholder: this.readonly ? '' : '请输入',
          label: '到达地',
          readonly: this.readonly,
          required: true,
          align: 'right'
        },
        {
          type: 'select',
          field: 'elementExt7',
          placeholder: this.readonly ? '' : '请选择',
          label: '交通工具类型',
          required: true,
          readonly: this.readonly,
          disabled: this.readonly,
          align: 'right',
          options: TYPE_OF_VEHICLE,
          render: (text) => renderTextWithConfig(text, TYPE_OF_VEHICLE)
        },
        {
          type: 'text',
          field: 'elementExt8',
          placeholder: this.readonly ? '' : '请输入',
          readonly: this.readonly,
          label: '等级',
          align: 'right'
        }
      ]
    }
  },
  mounted () {
    const specificElementVOs = this.useCache && getWebCache('specificElementVOs')
    if (specificElementVOs) {
      this.specificElementVOs = specificElementVOs
      setWebCache('specificElementVOs', null)
    } else {
      if (this.data && this.data.length) {
        this.specificElementVOs = this.data
      }
    }
  },
  methods: {
    initData () {
      this.specificElementVOs = [{
        elementExt1: '',
        elementExt2: '',
        elementExt3: '',
        elementExt4: '',
        elementExt5: '',
        elementExt6: '',
        elementExt7: '',
        elementExt8: '',
        elementExt9: '',
        elementExt10: ''
      }]
    },
    handleClearBusiness (e, index) {
      if (this.specificElementVOs.length <= 1 && this.elementCode !== '09') {
        return Notify({ type: 'danger', message: '除旅客运输外, 特定业务仅剩一条时，无法删除' })
      }
      this.specificElementVOs.splice(index, 1)
    },
    handleCheck () {
      let flag = true
      // 无论是单一还是多条都会有一套必填项
      const requiredFieldList = this.getColumnsByCode.filter(i => i.required).map(i => i.field)
      // 是单一的
      if (this.isSingle) {
        flag = requiredFieldList.every(i => !!this.specificElementVOs[0][i])
      } else {
        for (let index = 0; index < this.specificElementVOs.length; index++) {
          const element = this.specificElementVOs[index]
          flag = requiredFieldList.every(i => !!element[i])
          if (!flag) break
        }
      }
      if (!flag) {
        Notify({ type: 'danger', message: '请填写特定业务必填字段!' })
      } else {
        if (this.elementCode === '05' && !(this.specificElementVOs[0].elementExt3.split('').find(i => ['乡', '村', '路', '镇', '道', '巷', '号'].includes(i)))) {
          Notify({ type: 'danger', message: '详细地址必须包含 村/路/乡/镇/道/巷/号等关键字!' })
          flag = false
        }
        if (this.elementCode === '06') {
          const index = this.specificElementVOs.findIndex(i => (new Date(i.elementExt4).getTime() > new Date(i.elementExt5).getTime()))
          if (index !== -1) {
            Notify({ type: 'danger', message: `租赁结束日期不能小于租赁开始日期` })
            flag = false
          }
        }
      }

      return flag
    },
    handleAdd () {
      this.specificElementVOs.push({
        elementExt1: '',
        elementExt2: '',
        elementExt3: '',
        elementExt4: '',
        elementExt5: '',
        elementExt6: '',
        elementExt7: '',
        elementExt8: '',
        elementExt9: '',
        elementExt10: ''
      })
    },
    onInputChange ({ e, field, index }) {
      if (this.isSingle) {
        const item = this.specificElementVOs[0]
        if (this.elementCode === '06' && (field === 'elementExt4' || field === 'elementExt5')) {
          item['elementExt4'] = e[0] || ''
          item['elementExt5'] = e[1] || ''
        } else {
          item[field] = e
        }
        this.specificElementVOs.splice(0, 1, item)
      } else { // 多条
        const item = this.specificElementVOs[index]
        // 当改了旅客运输的交通工具类型需要切换等级
        if (this.elementCode === '09' && field === 'elementExt7') {
          item.elementExt8 = ''
        }
        item[field] = e
        this.specificElementVOs.splice(index, 1, item)
      }
    },
    onBlur ({ e, field }) {
    },
    onFocus ({ e, field }) {
    }
  }
}
</script>

<style lang="less" scoped>
  .specific-business-main{
    // 添加按钮
    .add{
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
      text-align: center;
      margin-top: 18px;
      cursor: pointer;
      height: 96px;
      border-radius: 8px;
      line-height: 96px;
      font-weight: bold;
      font-size: 30px;
      color: #3E4966;
      background-color: #F5F7FA;
    }
    background-color: #fff;
    padding: 12px 16px;
    box-sizing: border-box;
    font-size: 32px;
    header{
      font-weight: 600;
    }
    .business-item{
      // 删除按钮
      position: relative;
      border-bottom: 1px dashed rgba(220, 220, 220, 1);
      padding: 24px 0 32px;
      color: gray;
      margin-bottom: 24px;
      .clear{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 100;
      }
    }
    /deep/.van-field__label {
      font-size: 26px;
      font-weight: 400;
      color: #B3C1D1;
    }
  }
</style>
